module.exports = __webpack_public_path__ + "img/2.53d2bf7a.png";